import { Injectable, Signal, signal } from '@angular/core';
import { DataCard, StatusShipment } from '../components/utils';

@Injectable({
  providedIn: 'root'
})
export class SelectionService {
  private selections: Map<string, Map<string, DataCard>> = new Map();
  private readonly _searchedCard = signal<DataCard[] | undefined>(undefined);

  constructor() {}

  private getContextMap(context: string): Map<string, DataCard> {
    if (!this.selections.has(context)) {
      this.selections.set(context, new Map());
    }
    return this.selections.get(context)!;
  }


  toggleSelection(context: string, card: DataCard, selected: boolean): void {
    const contextMap = this.getContextMap(context);
    if (selected) {
      contextMap.set(card.visualId, card);
    } else {
      contextMap.delete(card.visualId);
    }
  }

  clearSelection(context: string): void {
    this.getContextMap(context).clear();
  }

  isSelected(context: string, id: string): boolean {
    return this.getContextMap(context).has(id);
  }

  getAllSelected(context: string): DataCard[] {
    return Array.from(this.getContextMap(context).values());
  }

  getConfirmedSelected(context: string): DataCard[] {
    return this.getAllSelected(context).filter(
      card =>
        card.status === StatusShipment.confirmed ||
        card.status === StatusShipment.scheduledCollection ||
        card.status === StatusShipment.toCollect ||
        card.status === StatusShipment.takeToDropOff
    );
  }

  getToPaySelected(context: string): DataCard[] {
    return this.getAllSelected(context).filter(card => card.status === StatusShipment.toPay);
  }

  setShipmentSearched(data: DataCard): void {
    this._searchedCard.set([data]);
  }

  clearSearchedCard(): void {
    this._searchedCard.set(undefined);
  }

  get searchedCard():Signal<DataCard[] | undefined> {
    return this._searchedCard;
  }

  clear() {
    this.selections.clear();
    this._searchedCard.set(undefined);
  }

  clearAllExcept(contextToKeep: string): void {
    for (const context of this.selections.keys()) {
      if (context !== contextToKeep) {
        this.clearSelection(context);
      }
    }
  }

  selectOnlySearched(context: string): void {
    const searched = this.searchedCard();
    this.clearAllExcept(context);
    this.clearSelection(context);

    if (searched && searched.length > 0) {
      const contextMap = this.getContextMap(context);
      contextMap.set(searched[0].visualId, searched[0]);
    }
  }

}
